import type { VariantProps } from '@gluestack-ui/utils/nativewind-utils'
import React from 'react'

import { textStyle } from './styles'

type ITextProps = React.ComponentProps<'span'> &
    VariantProps<typeof textStyle> & { numberOfLines?: number }

const Text = React.forwardRef<React.ComponentRef<'span'>, ITextProps>(function Text(
    {
        className,
        isTruncated,
        bold,
        underline,
        strikeThrough,
        size = 'md',
        sub,
        italic,
        highlight,
        numberOfLines,
        style,
        ...props
    }: { className?: string } & ITextProps,
    ref,
) {
    const lineClampStyle: React.CSSProperties | undefined =
        numberOfLines && numberOfLines > 0
            ? {
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: numberOfLines,
                  overflow: 'hidden',
              }
            : undefined

    return (
        <span
            className={textStyle({
                isTruncated: isTruncated as boolean,
                bold: bold as boolean,
                underline: underline as boolean,
                strikeThrough: strikeThrough as boolean,
                size,
                sub: sub as boolean,
                italic: italic as boolean,
                highlight: highlight as boolean,
                class: className,
            })}
            style={{ ...lineClampStyle, ...style }}
            {...props}
            ref={ref}
        />
    )
})

Text.displayName = 'Text'

export { Text }
